import { Grid, GridCol } from "@mantine/core";
import React, { useState, useEffect, useRef } from "react";
import "./contactPage.css";
import CustomButton from "../../components/CustomButton";
import Nav from "../../components/nav/Nav";
import { ReactComponent as CallIcon } from "../../assets/fi-rr-call-outgoing.svg";
import { ReactComponent as MailIcon } from "../../assets/fi-rr-envelope.svg";
import { ReactComponent as TimeIcon } from "../../assets/fi-rr-time-quarter-to.svg";
import Footer from "../../components/footer/Footer";
import { useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import base_url from "../../api/bootapi";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Phone } from "@mui/icons-material";
import { useDisclosure } from "@mantine/hooks";
import { Modal } from "@mantine/core";
import { ReactComponent as CloseIcon } from "../../assets/iconamoon_close.svg";
import { ReactComponent as ModalIcon } from "../../assets/modalLogo.svg";
import { ReactComponent as CircleTickIcon } from "../../assets/circle_tick.svg";

const ContactPage = () => {
  const [opened, { open, close }] = useDisclosure(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    watch,
  } = useForm();

  const postContactRequest = (data) => {
    const data2 = {
      full_name: data.full_name,
      email: data.email,
      message: data.message,
      from_site: "flyandclaim",
    };
    axios.post(`${base_url.api1}/tourapp/contact_us`, data2).then(() => {
      document.getElementById("myForm").reset();
      open();
    });
  };
  return (
    <>
      <div className=" contact-wrapper" style={{ minHeight: "100vh" }}>
        <Nav />

        <Modal
          opened={opened}
          onClose={close}
          centered
          radius={"xl"}
          size={"lg"}
          withCloseButton={false}
        >
          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "30px",
              padding: "48px",
            }}
          >
            {/* <CloseIcon
              style={{
                position: "absolute",
                top: "24px",
                right: "24px",
                cursor: "pointer",
              }}
              onClick={close}
            /> */}
            <CircleTickIcon />
            <h1
              className="header"
              style={{ color: "#314064", textAlign: "center" }}
            >
              Message sent successfully!
            </h1>
            <p
              style={{ textAlign: "center", color: "#222222" }}
              className="sub-header"
            >
              Thank you! Our team has received your message and will respond
              within 24–48 hours.
            </p>
            <CustomButton
              style={{ width: "50%" }}
              btnText={"BACK"}
              flex={1}
              onClick={close}
            />
          </div>
        </Modal>

        <div>
          <Grid
            className="inner-container"
            style={{ marginTop: "50px", padding: "0 0 50px 0" }}
          >
            <GridCol span={{ base: 12, lg: 6 }}>
              <div className="contact-header-text">
                <h1 className="contact-header">Contact us</h1>
                <p className="sub-header">
                  For inquiries, support, or additional information, please
                  contact us using the details below. We’re committed to
                  providing you with the best possible assistance.
                </p>

                <div className="contact-details-wrapper">
                  <div className="contact-grid-two">
                    <div className="left-input-wrapper">
                      <MailIcon />
                      <label>Email</label>
                      <span style={{ color: "#2271B8" }}>
                        claims@flyandclaim.com
                      </span>
                    </div>

                    <div className="left-input-wrapper">
                      <CallIcon />
                      <label>Phone</label>
                      <span style={{ color: "#2271B8" }}>845-212-0404</span>
                    </div>
                  </div>

                  <div
                    className="left-input-wrapper"
                    style={{ marginTop: "30px" }}
                  >
                    <TimeIcon />
                    <label>We’re here to help:</label>
                    <span className="sub-header">
                      Monday to Friday: 10:00 AM – 5:00 PM (EST)
                    </span>
                  </div>
                </div>
              </div>
            </GridCol>

            <GridCol span={{ base: 12, lg: 6 }}>
              <div className="contact-left">
                <h3>Get in touch</h3>
                <form id="myForm" onSubmit={handleSubmit(postContactRequest)}>
                  <div className="contact-grid-two">
                    <div className="input-wrapper">
                      <label>Full name</label>
                      <input
                        type="text"
                        placeholder="Enter your name"
                        name="full_name"
                        {...register("full_name", {
                          required: true,
                        })}
                        onKeyDown={(e) => {
                          const key = e.key;

                          // Allow only letters (A–Z, a–z), Backspace, Tab, Arrow keys
                          if (
                            !/^[a-zA-Z]$/.test(key) &&
                            ![
                              "Backspace",
                              "Tab",
                              "ArrowLeft",
                              "ArrowRight",
                            ].includes(key)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[A-Za-z\s]*$/.test(value)) {
                            setValue("full_name", value);
                          }
                        }}
                      />
                      {errors.full_name && (
                        <p className="errormessage">Name is Required</p>
                      )}
                    </div>

                    <div className="input-wrapper">
                      <label>Email</label>
                      <input
                        type="email"
                        placeholder="Enter your email"
                        name="email"
                        {...register("email", {
                          required: "Email Address is Required",
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Invalid email address",
                          },
                        })}
                        onKeyDown={(e) => {
                          // Block space
                          if (e.key === " ") {
                            e.preventDefault();
                          }

                          const invalidChars = [
                            "!",
                            "#",
                            "$",
                            "%",
                            "^",
                            "&",
                            "*",
                            "(",
                            ")",
                            ",",
                            "=",
                            "{",
                            "}",
                            "[",
                            "]",
                            ";",
                            ":",
                            '"',
                            "'",
                            "<",
                            ">",
                            "`",
                            "~",
                            "\\",
                            "|",
                            "?",
                          ];
                          if (invalidChars.includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                              value
                            )
                          ) {
                            setValue("email", value);
                          }
                        }}
                      />
                      {errors.email && (
                        <p className="errormessage">Email is Required</p>
                      )}
                    </div>
                  </div>

                  <div className="input-wrapper">
                    <label>Message</label>
                    <textarea
                      type="text"
                      rows={8}
                      placeholder="Type in your message"
                      name="message"
                      {...register("message", {
                        required: true,
                      })}
                    />
                    {errors.message && (
                      <p className="errormessage">Message is Required</p>
                    )}
                  </div>

                  <CustomButton btnText={"Get in touch"} />
                </form>
              </div>
            </GridCol>
          </Grid>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;
